import { getComplaintRequest, IComplaint } from '../../api/complaint';
import { IThunkActionCreator } from '../index';

export type TGetComplaintsActions = IComplaintsRequested | IComplaintsReceived | IComplaintsFailed;

interface IComplaintsRequested {
  type: 'IComplaintsRequested';
}

interface IComplaintsReceived {
  complaints: IComplaint[];
  type: 'IComplaintsReceived';
}

interface IComplaintsFailed {
  errorMessage: string;
  type: 'IComplaintsFailed';
}

/* istanbul ignore next */
export function getComplaints(category: number): IThunkActionCreator {
  return (dispatch, getState, context) => {
    dispatch<IComplaintsRequested>({
      type: 'IComplaintsRequested',
    });

    const moderationComplaintsBrowserUrl = context.config.get('moderationComplaints.browserUrl') as string;
    if (!moderationComplaintsBrowserUrl) {
      throw new Error(`'moderationComplaints.browserUrl' is not configured`);
    }

    const state = getState();
    const regionId = state.offerData.offer.geo.address[0].id;

    return getComplaintRequest(context.makeRequest, moderationComplaintsBrowserUrl, regionId, category)
      .then((response: IComplaint[]) => {
        dispatch<IComplaintsReceived>({
          complaints: response,
          type: 'IComplaintsReceived',
        });
      })
      .catch(() => {
        dispatch<IComplaintsFailed>({
          // tslint:disable-next-line:max-line-length
          errorMessage:
            'Произошла внутренняя ошибка сервиса. Информация об ошибке была направлена нашим разработчикам.',
          type: 'IComplaintsFailed',
        });
      });
  };
}
